//@constants
const actionTypes = require('constants/contactCenter/actionTypes');
const { ERROR_INVALID_PASSWORD, ERROR_USER_BLOCKED } = require('constants/contactCenter/errorTypes');

//@utilities
const {
    bindClientInteraction,
    securityLevelSetPromise,
    initSecurityInformation,
    raiseToN1ByPositions
} = require('utilities/contactCenter/authenticationActionsHelper');
const { isInOffice } = require('utilities/contactCenter/disasterRecoveryhelper');
const usd = require('utilities/usd');

const setPasswordError = error => ({
    type: actionTypes.CUSTOMER_FINDER_SET_PASSWORD_ERROR,
    payload: {
        error
    }
});

const authenticationRequestStart = () => ({
    type: actionTypes.CUSTOMER_FINDER_AUTHENTICATION_REQUEST_START
});

const authenticationRequestSuccessful = () => ({
    type: actionTypes.CUSTOMER_FINDER_AUTHENTICATION_REQUEST_SUCCESSFUL
});

const authenticationRequestError = error => ({
    type: actionTypes.CUSTOMER_FINDER_AUTHENTICATION_REQUEST_ERROR,
    payload: {
        error
    }
});

const confirmLogin = (interactionId, dropdownOption, positions, values, history) => (dispatch, getState) => {
    const inOffice = isInOffice();

    dispatch(authenticationRequestStart());

    return bindClientInteraction(interactionId, inOffice, dispatch, getState)
        .then(bindClientInteractionResponse => {
            const securityLevel = bindClientInteractionResponse.level ? bindClientInteractionResponse.level.trim() : '';

            initSecurityInformation(interactionId, securityLevel, getState);

            if (dropdownOption.global && (securityLevel === usd.securityLevels.ID)) {
                return raiseToN1ByPositions(interactionId, undefined, positions , values , dispatch, getState);
            } else {
                return securityLevelSetPromise(usd.securityLevels[securityLevel], dispatch);
            }
        })
        .then(response => {
            usd.setSecurityLevel(response.level);
            dispatch(authenticationRequestSuccessful());
            history.push(dropdownOption.value);
        })
        .catch(error => {
            switch(error.errorType) {
                case ERROR_INVALID_PASSWORD:
                case ERROR_USER_BLOCKED:
                    dispatch(setPasswordError(error));
                    break;
                default:
                    dispatch(authenticationRequestError(error));
            }
        });
};

module.exports = {
    confirmLogin
};
